import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=f2c7ec86&scoped=true"
import script from "./Doctor.vue?vue&type=script&lang=js"
export * from "./Doctor.vue?vue&type=script&lang=js"
import style0 from "./Doctor.vue?vue&type=style&index=0&id=f2c7ec86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c7ec86",
  null
  
)

export default component.exports